import React from 'react';
import { useState, useEffect, useRef} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { configData } from "../config";
import './classes/EditOrderInfoPage.css';
import SalespersonSidebar from "./SalespersonSidebar";
import { Helmet } from 'react-helmet';
import Loading from './Loading';	

const EditOrderInfoPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const[orderProducts,setOrderProducts] = useState([]);
    const [countrieslist, setCountriesList] = useState({});
    // const [stateslist, setStatesList] = useState({});
    const [shippingStatesList, setShippingStatesList] = useState({});
    const [billingStatesList, setBillingStatesList] = useState({});
    const[total,setOrderTotal] = useState([]);
    const[discounts,setDiscounts] = useState([]);
    const[shippingDetails,setShippingDetails] = useState({});
    const[billingDetails,setBillingDetails] = useState({});
    const[confbadge,setConfBadge] = useState([]);
    const [conferencefnamebadge, setConferenceFirstNameBadge] = useState({});
    const [conferencelnamebadge, setConferenceLastNameBadge] = useState({});
    const [conferenceschoolbadge, setConferenceSchoolBadge] = useState({}); 
    const [errors, setErrors] = useState({});
    const {uid} = useParams();
    const {order_id} = useParams();
    const navigate = useNavigate();
    const app_url = configData.APP_URL;

    const [formData, setFormData] = useState({
        bill_email: '',
        bill_country: '',
        bill_state: '',
        bill_firstname: '',
        bill_lastname: '',
        bill_address1: '',
        bill_address2: '',
        bill_zip: '',
        bill_city: '',
        bill_region: '',
        bill_phone: '',
        ship_email: '',
        ship_country: '',
        ship_state: '',
        ship_firstname: '',
        ship_lastname: '',
        ship_address1: '',
        ship_address2: '',
        ship_zip: '',
        ship_city: '',
        ship_region: '',
        ship_phone: '',
        drupal_orderid:order_id
    });

    const [edittedShippingData, setEdittedShippingData] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setErrors(prev => ({ ...prev, [name]: "" }));
        if (name.startsWith("ship")) {
            setEdittedShippingData(prev => ({ ...prev, [name]: true }));
        }
        // if (name === 'ship_country' || name === 'bill_country') {
        //     retrieveStatesList(value);
        // }
        if (name === 'ship_country') {
            setFormData(prev => ({
                ...prev,
                ship_country: value,
                ship_state: ""
            }));
            retrieveStatesList(value, 'shipping');
        }
        if (name === 'bill_country') {
            setFormData(prev => ({
                ...prev,
                bill_country: value,
                bill_state: ""
            }));
            retrieveStatesList(value, 'billing');
        }
    };

    const handleConferenceFirstNameBadge = (id, sku, value) => {
        setConferenceFirstNameBadge(prevState => ({
        ...prevState,
        [id]:{
            sku:sku,
            value:value
        },
        }));  
    };
    
    const handleConferenceLastNameBadge = (id, sku, value) => {
        setConferenceLastNameBadge(prevState => ({
        ...prevState,
        [id]:{
            sku:sku,
            value:value
        },
        }));
    };
    
    const handleConferenceSchoolBadge = (id, sku, value) => {
        setConferenceSchoolBadge(prevState => ({
        ...prevState,
        [id]:{
            sku:sku,
            value:value
        },
        }));
    };

    useEffect(() => {
        Promise.all([
            retrieveOrderDetails(),
            retrieveCountriesList()
        ])
        .then(() => {
        setIsLoading(false);
        })
    },[]);

    useEffect(() => {
        if (billingDetails?.country_id) {            
            retrieveStatesList(billingDetails.country_id, 'billing');
            setFormData(prev => ({
            ...prev,
            bill_email: billingDetails.email ?? "",
            bill_country: billingDetails.country_id ?? "",
            // bill_state: billingDetails.state_id ?? "",
            bill_firstname: billingDetails.firstname ?? "",
            bill_lastname: billingDetails.lastname ?? "",
            bill_address1: billingDetails.address ?? "",
            bill_address2: billingDetails.address1 ?? "",
            bill_zip: billingDetails.zipcode ?? "",
            bill_city: billingDetails.city ?? "",
            bill_region: billingDetails.region ?? "",
            bill_phone: billingDetails.phone ?? "",
            }));
        }

        if (shippingDetails?.country_id) {
            retrieveStatesList(shippingDetails.country_id, 'shipping');
            setFormData(prev => ({
            ...prev,
            ship_email: shippingDetails.email ?? "",
            ship_country: shippingDetails.country_id ?? "",
            // ship_state: shippingDetails.state_id ?? "",
            ship_firstname: shippingDetails.firstname ?? "",
            ship_lastname: shippingDetails.lastname ?? "",
            ship_address1: shippingDetails.address ?? "",
            ship_address2: shippingDetails.address1 ?? "",
            ship_zip: shippingDetails.zipcode ?? "",
            ship_city: shippingDetails.city ?? "",
            ship_region: shippingDetails.region ?? "",
            ship_phone: shippingDetails.phone ?? "",
            }));
        }
        if (confbadge?.length) {
            const firstNameData = {};
            const lastNameData = {};
            const schoolData = {};
            confbadge.forEach(item => {
            firstNameData[item.line_item_id] = {
                sku: item.sku ?? "",
                value: item.first_name_badge ?? ""
            };
            lastNameData[item.line_item_id] = {
                sku: item.sku ?? "",
                value: item.last_name_badge ?? ""
            };
            schoolData[item.line_item_id] = {
                sku: item.sku ?? "",
                value: item.school_name ?? ""
            };
            });

            setConferenceFirstNameBadge(firstNameData);
            setConferenceLastNameBadge(lastNameData);
            setConferenceSchoolBadge(schoolData);
        }
    }, [billingDetails, shippingDetails, confbadge]);

    useEffect(() => {
        if (shippingDetails?.state_id && Object.keys(shippingStatesList || {}).length && !formData.ship_state) {
            setFormData(prev => ({
                ...prev,
                ship_state: shippingDetails.state_id
            }));
        }
        if (billingDetails?.state_id && Object.keys(billingStatesList || {}).length && !formData.bill_state) {
            setFormData(prev => ({
                ...prev,
                bill_state: billingDetails.state_id
            }));
        }
    }, [shippingStatesList, billingStatesList]);
    
    async function retrieveOrderDetails() {
        const response = await fetch(
        app_url+'orderdetails/getorderdetails?uid='+uid+"&order_id="+order_id,
        {
            method: "GET",
            headers: {
            'Content-Type': 'application/json',
            },
        }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg === "Success") {
            setShippingDetails(responsedata.data.result['shipping']);
            setBillingDetails(responsedata.data.result['billing']);
            setOrderProducts(responsedata.data.result['product']);
            setDiscounts(responsedata.data.result['discounts']);
            setOrderTotal(responsedata.data.result['order_total']);
            setConfBadge(responsedata.data.conf_badge);
        } 
    }

    async function retrieveCountriesList() {
        try {
        const countrieslistresponse = await fetch(
        app_url+'smwwcommercecheckout/getcommercecountrieslist',
        {
            method: "GET",

            headers: {
            'Content-Type': 'application/json',
            },
        }
        )
        const countrieslistdata = await countrieslistresponse.json();
    
        const countrieslist = {};
        Object.keys(countrieslistdata.data.result).forEach(function(key) {
        
        countrieslist[key] = countrieslistdata.data.result[key];
    
        });
    
        setCountriesList(countrieslist);
        }  catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            
        }
    }

    async function retrieveStatesList(value, type) {
        try {
            if (!value) {
                if (type === 'shipping') setShippingStatesList({});
                if (type === 'billing') setBillingStatesList({});
                return;
            }

            const stateslistresponse = await fetch(
                app_url + 'smwwcommercecheckout/getcommercestateslist?country=' + value,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const stateslistdata = await stateslistresponse.json();
            const stateslist = {};

            Object.keys(stateslistdata.data.result).forEach(function (key) {
                stateslist[key] = stateslistdata.data.result[key];
            });

            if (type === 'shipping') {
                setShippingStatesList(stateslist);
            }

            if (type === 'billing') {
                setBillingStatesList(stateslist);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    function validateEmail(email) {
        const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regexp.test(email);
    }

    const isValidBasicPhone = (phone) => {
        const cleaned = phone.replace(/\D/g, ''); // Remove non-digit characters
        return cleaned.length >= 7 && cleaned.length <= 15;
    };

    const validateAddress = (data, prefix, edittedFields = null) => {
        const errors = {};
        const field = (name) => data[`${prefix}_${name}`];

        const shouldValidate = (name) => {
            if (!edittedFields) return true; 
            return edittedFields[`${prefix}_${name}`];
        };

        if (shouldValidate('email')) {
            if (!field('email')?.trim()) {
                errors[`${prefix}_email`] = 'Email is required';
            } else if (!validateEmail(field('email'))) {
                errors[`${prefix}_email`] = 'Invalid Email';
            }
        }

        if (shouldValidate('country') && !field('country')) {
            errors[`${prefix}_country`] = 'Country is required';
        }
        if (shouldValidate('state') && !field('state')) {
            errors[`${prefix}_state`] = 'State is required';
        }
        if (shouldValidate('firstname') && !field('firstname')?.trim()) {
            errors[`${prefix}_firstname`] = 'First Name is required';
        }
        if (shouldValidate('lastname') && !field('lastname')?.trim()) {
            errors[`${prefix}_lastname`] = 'Last Name is required';
        }
        if (shouldValidate('address1') && !field('address1')?.trim()) {
            errors[`${prefix}_address1`] = 'Address is required';
        }
        if (shouldValidate('zip') && !field('zip')?.trim()) {
            errors[`${prefix}_zip`] = 'Zip Code is required';
        }
        if (shouldValidate('city') && !field('city')?.trim()) {
            errors[`${prefix}_city`] = 'City is required';
        }
        if (shouldValidate('phone')) {
            if (!field('phone')?.trim()) {
                errors[`${prefix}_phone`] = 'Mobile Number is required';
            } else if (!isValidBasicPhone(field('phone'))) {
                errors[`${prefix}_phone`] = 'Invalid Phone Number';
            }
        }

        confbadge.forEach(item => {
            const prefix = item.line_item_id;
            if (!conferencefnamebadge[prefix]?.value?.trim()) {
                errors[`${prefix}_firstName`] =
                    `Please enter the conference first name badge for ${item.title}`;
            }

            if (!conferencelnamebadge[prefix]?.value?.trim()) {
                errors[`${prefix}_lastName`] =
                    `Please enter the conference last name badge for ${item.title}`;
            }

            if (!conferenceschoolbadge[prefix]?.value?.trim()) {
                errors[`${prefix}_school`] =
                    `Please enter the conference school badge for ${item.title}`;
            }
        });

        return errors;
    };

    const hasShippingData = () => {
        if (shippingDetails) return true;
        return Object.keys(formData).some(key => key.startsWith("ship") && formData[key]);
    };

    const validate = (data) => {
        return {
            ...(billingDetails ? validateAddress(data, 'bill') : {}),
            ...(hasShippingData() ? validateAddress(data, 'ship', edittedShippingData) : {}),
        };
    };

    const handleSubmit = async event => {
        event.preventDefault();

        const formErrors = validate(formData);
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors);
            // window.scrollTo(0,0);
            return;
        } else {
            const postData = {
                formData: formData,
                first_name_badge:conferencefnamebadge,
                last_name_badge:conferencelnamebadge,
                school_badge:conferenceschoolbadge,
            }
            // console.log(formData);
            setErrors({});
            const response = await fetch(app_url+'orderdetails/submitorderdetails', {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
                navigate("/user/"+uid+"/smww_orders/"+order_id, {state: { message: data.data.result}})
            } 
        }
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet><title>Edit Order</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="edit-order-details-container">
                        <div className="edit-order-details-page-section page-edit-myorder">
                            <div className="od-table-panel">
                                <h2>ORDER DETAILS</h2>
                                <div className='panelbody'>
                                    <table className="edit-order-details-page-table">
                                        <thead>
                                            <tr className="edit-order-details-page-odd">
                                                <th width="60%">Title</th>
                                                <th width="15%">Unit Price</th>
                                                <th width="15%">Price (Discount Applied)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {orderProducts.map((item, index) => (
                                                <tr className="order-details-page-even">
                                                    <td>{item.product_title}<br/>{item.classroom_text != '' &&
                                                    <span>{item.classroom_title+item.classroom_text}</span>
                                                    }</td>
                                                    <td className="right_align_text">${item.unit_amount}</td>
                                                    
                                                    <td className="right_align_text">${item.calculated_amount}</td>
                                                </tr>
                                            ))}
                                            {discounts &&<>
                                                {discounts.map((item, index) => (
                                                    <tr className="order-details-page-odd">
                                                        <td className='od-table-totals' colSpan="2">{item.name}</td>
                                                        
                                                        <td className="right_align_text">{item.amount}</td>
                                                    </tr>
                                                ))}
                                            </>}
                                            <tr className="order-details-page-odd">
                                                <td className='od-table-totals' colSpan="2">Total</td>
                                                <td className="right_align_text">{total}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="edit-order-form">
                            <form onSubmit={handleSubmit}>
                                <div className="edit_billing_info">
                                    <div className="order-sta-de">
                                        <h2>BILLING INFORMATION</h2>
                                    </div>
                                    <input 
                                        type="text" 
                                        name="bill_email" 
                                        id="bill_email" 
                                        placeholder="Email Address" 
                                        value={formData.bill_email} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_email &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_email}
                                        </span>
                                    }
                                    <select 
                                        id="bill_country" 
                                        name="bill_country"
                                        value={formData.bill_country} 
                                        onChange={handleChange}
                                    >
                                        <option value="">Country</option>
                                        {Object.keys(countrieslist).map(item => {
                                        return <option key={countrieslist[item].sortname} value={countrieslist[item].sortname}>{countrieslist[item].name}</option>
                                        })}
                                    </select>
                                    {errors.bill_country &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_country}
                                        </span>
                                    }
                                    <select 
                                        id="bill_state" 
                                        name="bill_state"
                                        value={formData.bill_state} 
                                        onChange={handleChange}
                                    >
                                        <option value="">Select State</option>
                                        {Object.keys(billingStatesList).map(state => {
                                            return <option key={billingStatesList[state].id} value={billingStatesList[state].id}>{billingStatesList[state].name}</option>
                                        })}
                                    </select>
                                    {errors.bill_state &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_state}
                                        </span>
                                    }
                                    <input 
                                        type="text"
                                        name="bill_firstname" 
                                        id="bill_firstname" 
                                        placeholder="First Name" 
                                        value={formData.bill_firstname} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_firstname &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_firstname}
                                        </span>
                                    }
                                    <input 
                                        type="text"
                                        name="bill_lastname" 
                                        id="bill_lastname" 
                                        placeholder="Last Name" 
                                        value={formData.bill_lastname} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_lastname &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_lastname}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="bill_address1"
                                        id="bill_address1"
                                        placeholder="Address"
                                        value={formData.bill_address1} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_address1 &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_address1}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="bill_address2"
                                        id="bill_address2"
                                        placeholder="Address (Optional)"
                                        value={formData.bill_address2} 
                                        onChange={handleChange}
                                    />
                                    <input
                                        type="text"
                                        name="bill_zip"
                                        id="bill_zip"
                                        placeholder="Zip Code"
                                        value={formData.bill_zip} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_zip &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_zip}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="bill_city"
                                        id="bill_city"
                                        placeholder="City"
                                        value={formData.bill_city} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_city &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_city}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="bill_region"
                                        id="region"
                                        placeholder="Region (Optional)"
                                        value={formData.bill_region} 
                                        onChange={handleChange}
                                    />
                                    <input
                                        type="text"
                                        name="bill_phone"
                                        id="bill_phone"
                                        maxlength="14"
                                        placeholder="Mobile No. "
                                        value={formData.bill_phone} 
                                        onChange={handleChange}
                                    />
                                    {errors.bill_phone &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.bill_phone}
                                        </span>
                                    }
                                </div>               
                                <div className="edit_shipping_info">
                                    <div className="order-sta-de">
                                        <h2>SHIPPING INFORMATION</h2>
                                    </div>
                                    <input 
                                        type="text" 
                                        name="ship_email"
                                        id="ship_email"
                                        placeholder="Email Address"
                                        value={formData.ship_email} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_email &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_email}
                                        </span>
                                    }
                                    <select
                                        id="ship_country"
                                        name="ship_country"
                                        value={formData.ship_country} 
                                        onChange={handleChange}
                                    >
                                        <option value="">Country</option>     
                                        {Object.keys(countrieslist).map(item => {
                                        return <option key={countrieslist[item].sortname} value={countrieslist[item].sortname}>{countrieslist[item].name}</option>
                                        })}                                     
                                    </select>
                                    {errors.ship_country &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_country}
                                        </span>
                                    }
                                    <select 
                                        id="ship_state" 
                                        name="ship_state"
                                        value={formData.ship_state} 
                                        onChange={handleChange}
                                    >
                                        <option value="">Select State</option>
                                        {Object.keys(shippingStatesList).map(state => {
                                            return <option key={shippingStatesList[state].id} value={shippingStatesList[state].id}>{shippingStatesList[state].name}</option>
                                        })}
                                    </select>
                                    {errors.ship_state &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_state}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="ship_firstname"
                                        id="ship_firstname"
                                        placeholder="First Name"
                                        value={formData.ship_firstname} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_firstname &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_firstname}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="ship_lastname"
                                        id="ship_lastname"
                                        placeholder="Last Name"
                                        value={formData.ship_lastname} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_lastname &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_lastname}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="ship_address1"
                                        id="ship_address1"
                                        placeholder="Address"
                                        value={formData.ship_address1} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_address1 &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_address1}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="ship_address2"
                                        id="ship_address2"
                                        placeholder="Address (Optional)"
                                        value={formData.ship_address2} 
                                        onChange={handleChange}
                                    />
                                    <input
                                        type="text"
                                        name="ship_zip"
                                        id="ship_zip"
                                        placeholder="Zip Code"
                                        value={formData.ship_zip} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_zip &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_zip}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="ship_city"
                                        id="ship_city"
                                        placeholder="City"
                                        value={formData.ship_city} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_city &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_city}
                                        </span>
                                    }
                                    <input
                                        type="text"
                                        name="ship_region"
                                        id="region"
                                        placeholder="Region (Optional)"
                                        value={formData.ship_region} 
                                        onChange={handleChange}
                                    />
                                    <input
                                        type="text"
                                        name="ship_phone"
                                        id="ship_phone"
                                        maxlength="14"
                                        placeholder="Mobile No. "
                                        value={formData.ship_phone} 
                                        onChange={handleChange}
                                    />
                                    {errors.ship_phone &&
                                        <span className="error-message" style={{marginTop:"0px"}}>
                                            {errors.ship_phone}
                                        </span>
                                    }
                                </div>
                                {confbadge.length > 0 && (
                                    <div className="name_badge">
                                        <div className="order-sta-de">
                                            <h2>CONFERENCE NAME BADGE</h2>
                                            {confbadge.map((item, index) => (
                                                <><p style={{marginBottom: "0px"}}><strong>{item.title}</strong></p>
                                                <div>
                                                    <label>Please enter your first name as you would like it to be displayed on your conference name badge</label>
                                                    <input
                                                        id={`firstName${item.line_item_id}`}
                                                        type="text"
                                                        name={`firstName[${item.line_item_id}]`}
                                                        value={conferencefnamebadge?.[item.line_item_id]?.value ?? ""}
                                                        onChange={(e) => handleConferenceFirstNameBadge(item.line_item_id, item.sku, e.target.value)}
                                                    />
                                                    {errors[`${item.line_item_id}_firstName`] && (
                                                        <span className="error-message" style={{ marginTop: "0px" }}>
                                                            {errors[`${item.line_item_id}_firstName`]}
                                                        </span>
                                                    )}
                                                </div>
                                                <div>
                                                    <label>Please enter your last name as you would like it to be displayed on your conference name badge</label>
                                                    <input 
                                                        id={"lastName"+item.line_item_id} 
                                                        type="text"
                                                        name={'lastName['+item.line_item_id+']'}
                                                        value={conferencelnamebadge?.[item.line_item_id]?.value ?? ""}
                                                        onChange={(e) => handleConferenceLastNameBadge(item.line_item_id, item.sku, e.target.value)}
                                                    />
                                                    {errors[`${item.line_item_id}_lastName`] && (
                                                        <span className="error-message" style={{ marginTop: "0px" }}>
                                                            {errors[`${item.line_item_id}_lastName`]}
                                                        </span>
                                                    )}
                                                </div>
                                                <div>
                                                    <label>Please enter your school or university as you would like it to be displayed on your conference name badge</label>
                                                    <input 
                                                        id={"school"+item.line_item_id} 
                                                        type="text"
                                                        name={'school['+item.line_item_id+']'}
                                                        value={conferenceschoolbadge?.[item.line_item_id]?.value ?? ""}
                                                        onChange={(e) => handleConferenceSchoolBadge(item.line_item_id, item.sku, e.target.value)}
                                                    />
                                                    {errors[`${item.line_item_id}_school`] && (
                                                        <span className="error-message" style={{ marginTop: "0px" }}>
                                                            {errors[`${item.line_item_id}_school`]}
                                                        </span>
                                                    )}
                                                </div>
                                            </>))}
                                        </div>  
                                    </div>
                                )}
                                <input 
                                    type="submit" 
                                    name="submit" 
                                    value="Submit" 
                                    className="submit" 
                                />					
                            </form>
                        </div>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default EditOrderInfoPage;